export const MODAL_CONFIRMATION_CODE_REQUIRED = 'confirmation code required';
export const MODAL_FORGOT_PASSWORD = 'forgot password';
export const MODAL_SUBMIT_NEW_PASSWORD = 'submit new password';
export const MODAL_LOGIN = 'login';
export const MODAL_REGISTER = 'register';
